import Tarefas from "../tarefas";

const ChecklistVeiculos = () => (
  <Tarefas
    tipoTarefa="CheckList de Veiculos"
    titulo="Acompanhamento - Checklist de Veículos"
  />
);

export default ChecklistVeiculos;